export const expandedMotionTypes: Record<string, string> = {
  peticao_inicial: 'PETICAO_INICIAL',
  peticao_diversa: 'PETICAO_DIVERSA',
  contestacao: 'CONTESTACAO',
  razoes_apelacao: 'RAZOES_APELACAO',
  contrarrazoes_apelacao: 'CONTRARAZOES_APELACAO',
  manifestacao_sobre_contestacao: 'MANIFESTACAO_SOBRE_CONTESTACAO',
  recurso_diverso: 'RECURSO_DIVERSO',
  contrarrazoes: 'CONTRARRAZOES',
  recurso: 'RECURSO',
}
